export default __webpack_public_path__ + "static/media/plane_turbine.d71356b6.png";